import type { ReactNode } from "react";
import { XStack } from "tamagui";

import Doctor from "@/assets/images/doctor.png";
import { Header, Heading, Image, Logo, Text } from "@/components";

type AffiliateImageTopBannerProps = {
  title: string;
  partnerLogo?: ReactNode;
};

const AffiliateImageTopBanner = ({
  title,
  partnerLogo,
}: AffiliateImageTopBannerProps) => (
  <Header
    height="$2400"
    $lg={{ height: "$3100" }}
    backgroundColor="$fillClinician"
    padding="$250"
    gap="$200"
  >
    <Text
      size="$xs"
      bold
      alignSelf="flex-start"
      backgroundColor="$backgroundGround"
      paddingHorizontal="$125"
      paddingVertical="$50"
      borderRadius="$1000"
      zIndex={1}
    >
      ACCESS CONFIRMED
    </Text>

    <Heading size="$lg" width="$3000" zIndex={1}>
      {title}
    </Heading>
    <XStack
      position="absolute"
      left="$250"
      bottom="$250"
      alignItems="center"
      gap="$75"
      zIndex={1}
    >
      <Logo height={10} width={79} $lg={{ height: 15, width: 120 }} />
      {partnerLogo && (
        <>
          <Text size="$sm" color="$textSecondary" $lg={{ lineHeight: "$300" }}>
            |
          </Text>
          {partnerLogo}
        </>
      )}
    </XStack>

    <Image
      source={Doctor}
      position="absolute"
      top="$200"
      bottom={0}
      right="$350"
      width="$2000"
      $md={{ top: "$200", width: "$2400", right: "$800" }}
      $lg={{ top: "$300", width: "$3000", right: "$1500" }}
      objectFit="cover"
      objectPosition="top center"
      pointerEvents="none"
    />
  </Header>
);

export default AffiliateImageTopBanner;
